/**
 * @module reducers
 * @description Redux reducer exports for VA Form 21-2680
 * Re-exports the root reducer configuration with save-in-progress support
 */

export { default } from './reducers';
